/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statschattitle2Inputs */

const en_statschattitle2 = /** @type {(inputs: Statschattitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan chats (7 days)`)
};

const de_statschattitle2 = /** @type {(inputs: Statschattitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan-Chats (7 Tage)`)
};

/**
* | output |
* | --- |
* | "Plan chats (7 days)" |
*
* @param {Statschattitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statschattitle2 = /** @type {((inputs?: Statschattitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statschattitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statschattitle2(inputs)
	return de_statschattitle2(inputs)
});
export { statschattitle2 as "statsChatTitle" }